/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 
/**
 * Terms & conditions validations
 */
function onCartSubmit(e) {  
    var terms = document.querySelector('.js-terms')
    var form = document.querySelector('.js-cart-form')
    var popup = document.querySelector('.js-terms-popup')

    if (!terms.checked) {
        e.preventDefault()
        popup.classList.add('open')
    } else {
        form.submit()
    }
}

/**
 * Accept terms & conditions
 */
function onAcceptTerms() {
    var terms = document.querySelector('.js-terms')
    var popup = document.querySelector('.js-terms-popup')
    var submit = document.querySelector('.Cart__Checkout');
    
    popup.classList.remove('open')
    terms.checked = true
    
    if ( submit ) {
      submit.click();
    }
}

function onDeclineTerms() {
	var popup = document.querySelector('.js-terms-popup')
    popup.classList.remove('open')
}


// Age popup
;(function(){
  
  var popup = document.querySelector('.js-age-popup');
  var ageCookie = getCookie('age_accepted');
  var pageContainer = document.querySelector('.PageContainer');
  
  var lockBody = function() {
    if ( pageContainer ) {
      pageContainer.style.pointerEvents = 'none';
      pageContainer.style.filter = 'blur(2px)';
      pageContainer.style.transition = 'all .2s ease';
    }
    
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = 0;
  };
  
  var unlockBody = function() {
    if ( pageContainer ) {
      pageContainer.style.pointerEvents = 'auto';
      pageContainer.style.filter = null;
    }
    
    document.body.style.position = 'relative';
    document.body.style.top = null;
  };
  
  if ( popup && !ageCookie ) {
    var accept = popup.querySelector('.js-accept-age');
    var decline = popup.querySelector('.js-decline-age');
    var redirectURL = decline.dataset.redirectUrl;
    
    popup.classList.add('open');
    lockBody();
    
    accept.addEventListener('click', function() {
      popup.classList.remove('open');
      unlockBody();
      setCookie('age_accepted', true, 365);
    });
    
    decline.addEventListener('click', function() {
      window.location.href = redirectURL ?? '/404';
    });
  }
  
})();

// Helpers
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

/**
 * Klaviyo API
 */
;(function(){
  /**
   * Klaviyo subscribe utility
   * @link https://github.com/estrattonbailey/klaviyo-subscribe
   * Compiled to ES5
   */
  function subscribe(listId, email) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var config = Object.assign({}, params, {
      g: listId,
      email: email
    });

    var body = Object.keys(config).reduce(function (str, key) {
      str.append(key, config[key]);
      return str;
    }, new URLSearchParams());

    return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      headers: {
        "Access-Control-Allow-Headers": "*",
        "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
      },
      body: body
    }).then(function (res) {
      return res.json();
    })
  }

  var newsletterForms = Array.from(document.querySelectorAll('[action="/contact#footer-newsletter"]'));

  if ( newsletterForms ) {
    newsletterForms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var email = form.querySelector('[name="contact[email]"]').value;

        subscribe(window.theme.klaviyo.listId, email).then(function(response) {
          if ( !response.success ) {
            var errorMsg = window.theme.klaviyo.error.replace('{{ error }}', response.errors);
            alert(errorMsg);
          }

          else if ( response.data.is_subscribed ) {
            alert(window.theme.klaviyo.isSubscribed);
          }

          else if ( response.success ) {
            var successEl = document.createElement('span');
            successEl.classList.add('success-el');
            successEl.innerHTML = window.theme.klaviyo.success;

            e.submitter.parentNode.insertBefore(successEl, e.submitter)
          }
        })
      })
    });
  }


})();


/**
 * Quick add from product item
 */
;(function(){
  
  var quickAddButtons = Array.from(document.querySelectorAll('[data-quick-add]'));
  
  if ( quickAddButtons.length ) {
    quickAddButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        
        var variantId = btn.dataset.variantId;
        var variantItemCount = btn.dataset.variantItemCount;
        if ( variantId ) quickAddVariant(variantId, btn, variantItemCount);
      });
    })
  }
  
  
  /**
   * Quick add variant
   * @param { String } id 
   * @param { HTMLElement } btn 
   */
  function quickAddVariant(id, btn, variantItemCount) {
    var payload = {
      'items': [
        {
          id,
          'quantity': 1,
          'properties': {
            '_metafield-item-count': variantItemCount ? variantItemCount : 0
          },
        },
      ],
    };
    
    fetch('/cart/add.js', {
      body: JSON.stringify(payload),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(function (response) {
      if (response.ok) {
        document.body.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { variant: id, quantity: 1 }
        }));
        
        btn.innerText = window.translations.productAdded;
        
        setTimeout(() => {
          btn.innerText = window.translations.quickAdd;
        }, 2500);
        
        return response.json();
      } else {
        throw new Error('Something went wrong');
      }
    })
    .catch(function (err) {
      console.log(err);
    });
  }
  
})();


